import React from 'react';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import { Button, Modal, OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Skeletons } from 'ui/components/skeleton';

import { Receivable } from 'services/action';

import { FormPayment, FormPartial } from '../form';

const initialState = {
  showDelete: false,
  showPayment: false,
  showPublish: false,
  showSend: false,
  typeSend: '',
  updatePartial: false,
  partialType: ''
};

export const Action = ({ data, onSubmit, isLoading,  }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const [{ showDelete, showPayment, showPublish, showSend, typeSend, updatePartial, partialType }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, showDelete: false, showPayment: false, showPublish: false, showSend: false, typeSend: '', updatePartial: false, partialType: '' }));
  };

  const $sendEmail = async () => {
    let wa = false
    if (typeSend === 'attachments') {
      wa = true
    }

    const result = await Dispatch(Receivable.$emailReceivable(data?.id, {with_attachment: wa}));
    if (result?.message === 'success') {
      $handleClose()
    }
  }

  const $handleDownload = async() => {
    window.open(data?.pdf_url, '_blank');
  }

  const $handleDelete = async () => {
    const del = await Dispatch(Receivable.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      History.replace('/receivable');
    }
  };

  const $handlePublish = async () => {
    const result = await Dispatch(Receivable.$publish(data?.id));
    if (result?.message === 'success') {
      $handleClose();
      onSubmit();
    }
  };

  const StandardAction = () => {
    return (
      <>
        {(data?.document_status === 'new' || data?.document_status === 'published') && (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
          >
            <Link
              to={`/receivable/update/${data?.id}`}
              className={cn('btn btn-primary px-2')}
            >
              <Fi.FiEdit size="17" />
            </Link>
          </OverlayTrigger>
        )}

        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={`tooltip-top`}>Duplikat</Tooltip>}
        >
          <Link
            to={`/receivable/duplicate/${data?.id}`}
            className={cn('btn btn-primary px-2')}
          >
            <Fi.FiCopy size="17" />
          </Link>
        </OverlayTrigger>

        {data?.document_status === 'new' && (
          <>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
            >
              <button
                className={cn('btn btn-danger px-2')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showDelete: true }))
                }
              >
                <Fi.FiTrash2 size="17" />
              </button>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Tagihkan</Tooltip>}
            >
              <button
                className={cn('btn btn-primary px-2')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showPublish: true }))
                }
              >
                <Fi.FiCheckCircle size="17" />
              </button>
            </OverlayTrigger>
          </>
        )}

        {data?.document_status !== 'paid' && data?.document_status !== 'new' && (
          <>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Buat Pembayaran</Tooltip>}
            >
              <button
                className={cn('btn btn-secondary px-2')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showPayment: true }))
                }
              >
                <Fi.FiCreditCard size="17" />
              </button>
            </OverlayTrigger>
          </>
        )}
      </>
    );
  };

  const PrintAction = () => {
    return (
      <Dropdown className="d-inline p-0 m-0 split-carret" as="div" align="end">
        <Dropdown.Toggle
          id="dropdown-autoclose-true"
          className="d-flex p-0 justify-content-between "
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Print</Tooltip>}
          >
            <div
              className=" border-end border-light"
              style={{ padding: '4.4px 8px' }}
            >
              <Fi.FiPrinter size="17" className=" border-end" />
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>
        <Dropdown.Menu className="py-0 rounded-2">
          <div
            className="dropdown-item d-flex align-items-center cursor-pointer  "
            onClick={$handleDownload}
          >
            <Fi.FiDownload size={15} color="#202020" className="me-2" />
            Download Invoice
          </div>

          <Link
            to={`/print/receivable/${data?.id}`}
            className="dropdown-item d-flex align-items-center cursor-pointer  "
            target="_blank"
          >
            <Fi.FiPrinter size={15} color="#202020" className="me-2" />
            Print Invoice
          </Link>
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  const SettingAction = () => {
    return (
      <Dropdown className="d-inline p-0 m-0 split-carret" as="div" align="end">
        <Dropdown.Toggle
          id="dropdown-autoclose-true"
          className="d-flex p-0 justify-content-between "
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Pengaturan</Tooltip>}
          >
            <div
              className=" border-end border-light"
              style={{ padding: '4.4px 8px' }}
            >
              <Fi.FiSettings size="17" className=" border-end" />
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>
        <Dropdown.Menu className="py-0 rounded-2">
          {(data?.document_status !== 'new' && data?.customer?.is_send_invoice) && (
            <div
              className="dropdown-item d-flex align-items-center cursor-pointer  "
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  updatePartial: true,
                  partialType: 'shipment_code'
                }))
              }
            >
              <Fi.FiEdit size={15} color="#202020" className="me-2" />
              Input Resi
            </div>
          )}
          <div
            className="dropdown-item d-flex align-items-center cursor-pointer  "
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                updatePartial: true,
                partialType: 'attachments'
              }))
            }
          >
            <Fi.FiFile size={15} color="#202020" className="me-2" />
            Perbaharui Attachments
          </div>
          <div
            className="dropdown-item d-flex align-items-center cursor-pointer  "
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                updatePartial: true,
                partialType: 'emails'
              }))
            }
          >
            <Fi.FiMail size={15} color="#202020" className="me-2" />
            Perbaharui Email
          </div>
          <div
            className="dropdown-item d-flex align-items-center cursor-pointer  "
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                updatePartial: true,
                partialType: 'additional'
              }))
            }
          >
            <Fi.FiCreditCard size={15} color="#202020" className="me-2" />
            Perbaharui Admin/Return
          </div>
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  const SendEmailAction = () => {
    return (
      <Dropdown className="d-inline p-0 m-0 split-carret" as="div" align="end">
        <Dropdown.Toggle
          id="dropdown-autoclose-true"
          className="d-flex p-0 justify-content-between "
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Kirim Email</Tooltip>}
          >
            <div
              className=" border-end border-light"
              style={{ padding: '4.4px 8px' }}
            >
              <Fi.FiSend size="17" className=" border-end" />
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>
        <Dropdown.Menu className="py-0 rounded-2">
          <div
            className="dropdown-item d-flex align-items-center cursor-pointer  "
            onClick={() =>
              setState((prevState) => ({ ...prevState, showSend: true, typeSend: 'receivable' }))
            }
          >
            <Fi.FiFileText size={15} color="#202020" className="me-2" />
            Kirim Invoice
          </div>
          {data?.attachments?.length > 0 && (
            <div
              className="dropdown-item d-flex align-items-center cursor-pointer  "
              onClick={() =>
                setState((prevState) => ({ ...prevState, showSend: true, typeSend: 'attachments' }))
              }
            >
              <Fi.FiFile size={15} color="#202020" className="me-2" />
              Kirim Attachments
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  return (
    <div className="d-flex align-items-center gap-1 px-md-3 px-2  px-md-0 pb-2 pb-md-0">
      {isLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          <StandardAction />
          <PrintAction />
          {data?.document_status !== 'new' && (
            <SettingAction />
          )}
          {data?.emails?.length > 0 && (
            <SendEmailAction />
          )}
        </>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal publish */}
      <Modal
        show={showPublish}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <Fi.FiAlertTriangle className="mb-2 text-primary" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Dokumen ini akan ditagihkan ke customer
          </p>

          {/* {isError ? (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {isError?.id}
            </div>
          ) : null} */}
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handlePublish}
                disabled={StateForm?.loading}
              >
                Tagihkan
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal send email */}
      <Modal
        show={showSend}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Dokumen akan dikirimkan melalui email
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$sendEmail}
                disabled={StateForm?.loading}
              >
                Kirim
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal payment */}
      <Modal
        show={showPayment}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Buat Pembayaran</Modal.Title>
        </Modal.Header>
        <FormPayment
          data={data}
          onClose={() => {
            onSubmit();
            $handleClose();
          }}
        />
      </Modal>

      {/* modal update */}
      <Modal
        show={updatePartial}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="lg"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui {partialType?.replace('additional', 'Admin/Return')}</Modal.Title>
        </Modal.Header>
        <FormPartial
          data={data}
          updateType={partialType}
          onClose={() => {
            onSubmit();
            $handleClose();
          }}
        />
      </Modal>
    </div>
  );
};
